import {
  dashboardWidgetRegistry,
  NewsWidget,
  WidgetUpgradeBadge,
  widgetMenuEntryToItem,
} from '@/core/widgets/export';
import { useEffectivePermissions } from '@/core/permissions/export';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { MenuList, MenuListItem } from '@/shared/components/export';
import styles from '@/app/dashboard/components/dashboard-add-item-control.module.css';
import '@/shared/theme/navbar-buttons.scss';

export default function DashboardAddItemControl({
  onAddWidget,
  activeWidgets,
}: {
  onAddWidget: (w: string) => void;
  activeWidgets: NewsWidget[];
}) {
  const permissions = useEffectivePermissions();

  const items: MenuListItem[] = [
    ...dashboardWidgetRegistry
      .getAll()
      .filter(value => !activeWidgets.find(w => value.id === w.id))
      .filter(value => !(value.shouldHideToUser && value.shouldHideToUser(permissions) === true))
      .map(value => ({
        key: value.id,
        label: (
          <>
            {value.headerPanel}{' '}
            <sup>
              <WidgetUpgradeBadge widget={value} />
            </sup>
          </>
        ),
        onSelect: () => onAddWidget(value.id),
      })),
    { key: 'divider', label: '', divider: true },
    ...dashboardWidgetRegistry
      .getFactories()
      .filter(value => value.getListableUrls().length > 0)
      .map((value, index) => ({
        key: `fact-${index}`,
        label: value.headerPanel,
        collapsible: value
          .getListableUrls()
          .map((entry, entryIndex) =>
            widgetMenuEntryToItem(entry, `fact-${index}-${entryIndex}`, { onSelect: onAddWidget }),
          ),
      })),
  ];

  return (
    <MenuList
      trigger={<FontAwesomeIcon icon={faPlus} style={{ fontSize: '1.15em' }} />}
      toggleClassName={'btn btn-outline-primary-500 btn-sm navbar-btn navbar-btn-square'}
      toggleTitle={'Add Item'}
      align={'right'}
      items={items}
      elevated
      menuClassName={styles.dropdownButton}
    />
  );
}
